import axios from 'axios';

const API_URL = 'https://apischlinux.trayistats.com';

export const loginService = async (credentials) => {
  try {
    
    const response = await axios.post(`${API_URL}/api/auth/Login`, credentials);
    const token = response.data?.result?.data[0]?.Token;
    if (!token) {
      throw new Error('Token not found in response');
      
    }
    return { token, userInfo: response.data };
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'The email or password you entered is incorrect.';
    throw new Error(errorMessage);
  }
};
